<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template xmlns="">
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <cvc-form v-if="company.nameCompany === companiesEnumsData.CVC" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <acuavalle-form v-if="company.nameCompany === companiesEnumsData.ACUAVALLE" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <ozono-form v-if="company.nameCompany === companiesEnumsData.OZONO" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <comite-c-q-form v-if="company.nameCompany === companiesEnumsData.COMITECQ" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <aguas-de-buga-form v-if="company.nameCompany === companiesEnumsData.AGUASDEBUGA" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <epm-form v-if="company.nameCompany === companiesEnumsData.EPM" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <acuagyr-form v-if="company.nameCompany === companiesEnumsData.ACUAGYR" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <arquitecsoft-form-v2 v-if="company.nameCompany === companiesEnumsData.ARQUITECSOFT" :casoDataProp="casoDataProp" :modeCreateProp="modeCreate"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <brilla-form v-if="company.nameCompany === companiesEnumsData.BRILLA" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <imedical-form v-if="company.nameCompany === companiesEnumsData.IMEDICAL" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <meso-food-form v-if="company.nameCompany === companiesEnumsData.MESOFOODS || company.nameCompany === companiesEnumsData.PRESTO_MESOFOODS || company.nameCompany === companiesEnumsData.OMA_MESOFOODS" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <energuate-form v-if="company.nameCompany === companiesEnumsData.ENERGUATE" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <castell-form v-if="company.nameCompany === companiesEnumsData.CASTELL" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />

    <syscasoft-form v-if="company.nameCompany === companiesEnumsData.SYSCASOFT" :casoDataProp="casoDataProp"
      :createNewCasoProp="createNewCaso" :editCasoProp="editCaso" :closeSidebarProp="closeSidebar" />
  </div>
</template>

<script>
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Create component
const FilePond = vueFilePond()
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
import CasoModule from '@/store/caso-module/moduleDataList.js'
import SubCategoriaModule from '@/store/sub-categoria-module/moduleDataList.js'
import ListasModule from '@/store/listas-module/moduleDataList.js'
import CuentaAliadaModule from '@/store/cuenta-aliada-module/moduleDataList.js'
import DatoAdicionalModule from '@/store/dato-adicional-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'
import { searchCompany, companiesEnums } from '../../config/companies.js'

import CvcForm from '@/views/caso/formularios/CvcForm.vue'
import AcuagyrForm from '@/views/caso/formularios/AcuagyrForm.vue'
import ArquitecsoftForm from '@/views/caso/formularios/ArquitecsoftForm.vue'
import ArquitecsoftFormV2 from '@/views/caso/formularios/ArquitecsoftFormV2.vue'
import AcuavalleForm from '@/views/caso/formularios/AcuavalleForm.vue'
import OzonoForm from '@/views/caso/formularios/OzonoForm.vue'
import EpmForm from '@/views/caso/formularios/EpmForm.vue'
import ComiteCQForm from '@/views/caso/formularios/ComiteCQForm.vue'
import AguasDeBugaForm from '@/views/caso/formularios/AguasDeBugaForm.vue'
import BrillaForm from '@/views/caso/formularios/BrillaForm.vue'
import EnerguateForm from '@/views/caso/formularios/EnerguateForm.vue'
import ImedicalForm from '@/views/caso/formularios/ImedicalForm.vue'
import MesoFoodForm from '@/views/caso/formularios/MesoFoodForm.vue'
import CastellForm from '@/views/caso/formularios/CastellForm.vue'
import SyscasoftForm from '@/views/caso/formularios/SyscasoftForm.vue'

export default {
  components: {
    Datepicker,
    flatPickr,
    FilePond,
    CvcForm,
    AcuagyrForm,
    ArquitecsoftForm,
    ArquitecsoftFormV2,
    AcuavalleForm,
    OzonoForm,
    EpmForm,
    ComiteCQForm,
    AguasDeBugaForm,
    BrillaForm,
    EnerguateForm,
    ImedicalForm,
    MesoFoodForm,
    CastellForm,
    SyscasoftForm
  },
  props: {
    casoDataProp: {
      type: Object,
      default: () => { }
    },
    tipoActividadProp: {
      type: Object,
      default: undefined
    },
    tipoActividadExternaProp: {
      type: Object,
      default: undefined
    },
    subProyectoProp: {
      type: Object,
      default: undefined
    },
    serviciosProp: {
      type: Object,
      default: undefined
    },
    criticalityProp: {
      type: Object,
      default: undefined
    },
    itilIncidentTypeProp: {
      type: Object,
      default: undefined
    },
    applicativeProp: {
      type: Object,
      default: undefined
    },
    helpDeskProp: {
      type: Object,
      default: undefined
    },
    gesActivosProp: {
      type: Object,
      default: undefined
    },
    modeCreateProp: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      company: searchCompany(this.$route.params.nameCompany),
      companiesEnumsData: companiesEnums,
      user_not_found: false,
      modeCreate: true
    }
  },
  computed: {
  },
  created () {
    this.modeCreate = this.modeCreateProp

    if (!CasoModule.isRegistered) {
      this.$store.registerModule('CasoModule', CasoModule)
      CasoModule.isRegistered = true
    }
    if (!CuentaAliadaModule.isRegistered) {
      this.$store.registerModule('CuentaAliadaModule', CuentaAliadaModule)
      CuentaAliadaModule.isRegistered = true
    }
  },
  methods: {
    initListOfValues () {

      if (!SubCategoriaModule.isRegistered) {
        this.$store.registerModule('SubCategoriaModule', SubCategoriaModule)
        SubCategoriaModule.isRegistered = true
      }

      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      if (!DatoAdicionalModule.isRegistered) {
        this.$store.registerModule('DatoAdicionalModule', DatoAdicionalModule)
        DatoAdicionalModule.isRegistered = true
      }

      if (this.company.idCompany !== 1) {

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividadExterna', this.company)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllCriticality', this.company)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllItilIncidentType', this.company)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAllSubProyecto', this.company)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()

          // this.$vs.dialog({
          //   color: 'danger',
          //   title: 'Error',
          //   text:
          //     'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          //   acceptText: 'Aceptar'
          // })
        })

    },
    confirmDeleteRecord (casoId) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar el caso "${casoId}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    displayMessage (casoId) {
      this.$vs.dialog({
        color: 'primary',
        title: 'Modificar registro',
        text: `Modificación del caso id = ${casoId}`,
        accept: console.log('texto')
      })
    },
    deleteRecord () {
      this.showDeleteSuccess()
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Caso eliminado',
        text: 'El caso ha sido eliminada del sistema.'
      })
    },
    closeSidebar () {
      this.$emit('closeEdit')
      //this.initParams(true)
    },
    createNewCaso (casoDataProp) {
      //console.log('Enviando datos a crear: ', JSON.stringify(casoDataProp))

      this.$vs.loading()
      this.$store
        .dispatch('CasoModule/addCaso', casoDataProp)
        .then((response) => {

          // Guarda la relación entre el caso y la cuenta

          if (casoDataProp.cuenta && casoDataProp.cuenta.id !== -1) {

            const dataTmp = {
              accountId: casoDataProp.cuenta.id,
              idRequest: response.id
            }

            this.$store
              .dispatch('CuentaAliadaModule/createAccountRequestRel', dataTmp)
              .then((result) => {
                console.log('createAccountRequestRel result, ', result)
              })
              .catch((error) => {
                console.log('createAccountRequestRel error, ', error)
              })
          }

          if(casoDataProp.additionalData && casoDataProp.additionalData.length > 0) {
            casoDataProp.additionalData.forEach((item) => {
              item.id_request = response.id
            })

            console.log('casoDataProp.additionalData, ', casoDataProp.additionalData)

            this.$store
            .dispatch('DatoAdicionalModule/setAdditionalData', casoDataProp.additionalData)
            .then((result) => {
              console.log('setAdditionalData result, ', result)
            }).catch((error) => {
              console.log('setAdditionalData error, ', error)
            })
          }

          // Guarda los archivos

          let count = 0

          if (casoDataProp.myFiles.length > 0) {
            casoDataProp.myFiles.forEach(file => {
              const payload = {
                idCaso: response.id,
                idUser: this.$store.state.auth.userDetails().id,
                files: file
              }

              this.$store
                .dispatch('CasoModule/addFilesCaso', payload)
                .then((result) => {

                  const payload2 = {
                    id_request: response.id,
                    name_attachments: file.name,
                    cloud_ubication: result.cloudUbi,
                    create_id_user: payload.idUser
                  }

                  this.$store
                    .dispatch('CasoModule/createFileCaso', payload2)
                    .then(() => {

                      count++
                      if (count === this.files.length) {
                        this.resultCreateNewCaso(payload.idCaso)
                      }
                    }).catch(() => {
                      this.resultCreateNewCaso(payload.idCaso)
                    })
                })
                .catch((error) => {
                  console.log('addFilesCaso error, ', error)
                  this.resultCreateNewCaso(payload.idCaso)
                })
            })
          } else {
            this.resultCreateNewCaso(response.id)
          }
        })
        .catch((ex) => {
          this.$vs.loading.close()
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOK !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    resultCreateNewCaso (casoIdTmp) {
      this.$vs.loading.close()

      this.$emit('refresh')
      this.$emit('closeEdit')
      //this.initParams(true) // Limpiar campos del formulario
      this.$vs.dialog({
        color: 'success',
        title: 'Caso creado',
        text: `El caso "${casoIdTmp}" ha sido creado correctamente.`,
        acceptText: 'Aceptar'
      })
    },
    editCaso (casoDataProp) {
      //console.log('Enviando datos a guardar: ', casoDataProp)

      this.$store
        .dispatch('CasoModule/updateCaso', casoDataProp)
        .then(() => {
          this.$emit('refresh')
          this.$emit('closeEdit')
          //this.initParams(true) // Limpiar campos del formulario
          this.$vs.dialog({
            color: 'success',
            title: 'Caso actualizado',
            text: 'El caso ha sido actualizado correctamente.',
            acceptText: 'Aceptar'
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOK !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}

.flatpickr-input.active {
  border: 1px solid rgba(var(--vs-primary), 1);
}

.flatpickr-calendar .flatpickr-day.selected {
  background: rgba(var(--vs-primary), 1) !important;
  box-shadow: none;
  border-color: rgba(var(--vs-primary), 1) !important;
}
</style>
